import Switcher from "./utils/Switcher";
import Site from "./Site";
import Form from "../../modules/core/forms/theme/js/Form";

interface CartAddress {
    firstname?: string;
    lastname?: string;
    address?: string;
    zipcode?: string;
    city?: string;
}

export default class Cart {
    public static removeItem(uid: string, activeafter: boolean, onsuccess?: () => void): void {
        const $cartbox = $('.header__cartbox');

        $.post('/cartapi/remove', {
            id: uid,
        }, (r) => {
            $cartbox.html(r.carthtml);

            $('#cart .badge').addClass('flash');

            setTimeout(() => {
                $('#cart .badge').removeClass('flash');
            }, 1000);

            if (activeafter) {
                const $items2 = $('.shopping-cart-items > li');

                if ($items2.length) {
                    $('.shopping-cart').addClass('active');
                }
            }

            if (onsuccess) {
                onsuccess();
            }
        });
    }

    public static showAddressForm(uid: string, addr: CartAddress, onsuccess?: (r: CartAddress) => void): void {
        const $modal = $('.cartform__modal-address').clone();
        const $_modal = (<any> $modal);
        const $form = $('form', $modal);

        $('input[name="firstname"]', $form).val(addr.firstname);
        $('input[name="lastname"]', $form).val(addr.lastname);
        $('input[name="address"]', $form).val(addr.address);
        $('input[name="zipcode"]', $form).val(addr.zipcode);
        $('input[name="city"]', $form).val(addr.city);

        $_modal.modal({});

        $modal.on('hidden.bs.modal', () => {
            $modal.remove();
        });

        $form.on('submit', (e) => {
            e.preventDefault();

            $.ajax({
                url: '/cartapi/address/' + uid,
                method: 'post',
                data: $form.serializeArray(),

                success: (r) => {
                    $_modal.modal('hide');

                    if (onsuccess) {
                        onsuccess(r.address);
                    }
                },
            });
        });
    }

    public static onSummaryForm($uid: JQuery): void {
        new Form($uid);
    }

    public static onUserForm($uid: JQuery): void {
        new Form($uid);

        Switcher.init($('input[name="iscompany"]', $uid), $('._js-forcompany', $uid));
    }

    public static onService($uid: JQuery): void {
        $(':input', $uid).on('change', (e) => {
            Site.dispatchUpdateCartStart();

            var data={
                group: $(this).data('group'),
                id: $(this).val()
            };

            $.post('/cartapi/services', data, function() {
                Site.dispatchUpdateCart();
            });
        });
    }

    public static onServicesForm($uid: JQuery): void {
        (function($) {
            $('body').one('cartUpdateInit', function() {
                $uid.find(':input').prop('disable', 'disable');
            });

            $('body').one('cartUpdate', function() {
                const url = $uid.data('update');

                $.get(url, (r) => {
                    $uid.replaceWith(r);
                });
            });
        })(jQuery);
    }

    public static onCartFormProducts($uid: JQuery): void {
    }

    public static onCartForm($uid: JQuery): void {
        const $next = $('.cartform__next', $uid);
        const $products = $('.cart-products__item', $uid);

        const updateAddress = ($item: JQuery, address: CartAddress) => {
            const $address = $('.cart-products__address', $item);

            if (!address) {
                $address.text('Ustaw adres dostawy');
                return;
            }

            const html = `
                ${address.firstname} ${address.lastname}<br>
                ${address.address}<br>
                ${address.zipcode} ${address.city}
            `;

            $address.html(html);
        };

        const updateState = () => {
            $.get('/cartapi/isready', (r) => {
                $('.cartform__next').toggleClass('disabled', !r.cart);
            });
        };

        $products.each((ix, el) => {
            const $item = $(el);
            const $address = $('.cart-products__address', $item);
            const $addressbtn = $('.cart-products__addressbtn', $item);
            const $removebtn = $('.cart-products__removebtn', $item);
            const uid = $item.data('id');

            let addr: CartAddress = $item.data('address');

            updateAddress($item, addr);

            $removebtn.on('click', (e) => {
                this.removeItem(uid, false, () => {
                    $item.fadeOut(() => {
                        $item.remove();
                        updateState();
                    });
                });
            });

            $addressbtn.on('click', (e) => {
                this.showAddressForm(uid, addr, (r) => {
                    updateAddress($item, r);
                    updateState();

                    addr = r;
                });
            });
        });

        $next.on('click', (e) => {
            if ($next.hasClass('disabled')) {
                e.preventDefault();
            }
        });
    }
}
